import React from 'react';
import Radio from 'relements/build/esm/input/radio';
import Box from 'relements/build/esm/ui/box';
import Tooltip from 'relements/build/esm/overlays/tooltip';
import InfoIconV4 from 'relements/build/esm/ui/icons/InfoIconV4';
import { isProduction } from '@src/utils';
import { feedbackFrequencyInfo } from '../constants';

function FeedbackFrequency({ options, onChange, value, label }) {
  return (
    <div>
      <Box padding="0" marginBottom="16px" marginTop="32px">
        {label}

        <Tooltip themed tooltip={feedbackFrequencyInfo} position="TOP">
          <InfoIconV4 size="small" iconColor="grey.dark" marginLeft="4px" />
        </Tooltip>
      </Box>
      <Radio
        options={options}
        onChange={onChange}
        value={value}
        disabled={isProduction()}
      />
    </div>
  );
}

export default FeedbackFrequency;
